import React, { useState, useEffect } from 'react';
import styled from "styled-components";

export const RibbonContainer: any = styled.div<{ }>`
    /* common */
    .ribbon {
      width: 120px;
      height: 97px;
      overflow: hidden;
      position: absolute;

        .ribbonContent {
            position: absolute;
            display: block;
            width: 210px;
    /*      padding: 5px 0px;*/
        padding: 6px 0px;
            background: #3498db;
            box-shadow: 0 5px 10px rgba(0,0,0,.1);
            color: #fff;
    /*      font: 600 13px/1 Inter, sans-serif !important;*/
        font: 600 11px/1 Inter, sans-serif !important;
            text-shadow: 0 1px 1px rgba(0,0,0,.2);
            text-transform: uppercase;
            text-align: center;
        }

        &::before,&::after {
            position: absolute;
            z-index: 1;
            content: '';
            display: block;
            border: 5px solid #2980b9;
        }
    }

    .ribbon-success {
        .ribbonContent {
            background: #00bd9d;
        }

        &::before,&::after {
            border-color: #00715d;
        }
    }

    .ribbon-danger {
        .ribbonContent {
            background: #f06548;
        }

        &::before,&::after {
            border-color: #da3412;
        }
    }

    .ribbon-pending {
        .ribbonContent {
            background: #ffbc0a;
        }

        &::before,&::after {
            border-color: #d9a009;
        }
    }

    .ribbon-top-left {
      top: -10px;
      left: -10px;
    }

    /* top left*/
    .ribbon-top-left {
      top: -10px;
      left: -10px;
    }
    .ribbon-top-left::before,
    .ribbon-top-left::after {
      border-top-color: transparent;
      border-left-color: transparent;
    }
    .ribbon-top-left::before {
      top: 0;
      right: 23px;
    }
    .ribbon-top-left::after {
      bottom: 0;
      left: 0;
    }
    .ribbon-top-left span {
      right: -25px;
      top: 30px;
      transform: rotate(-45deg);
    }

    /* top right*/
    .ribbon-top-right {
      top: -10px;
      right: -10px;
    }
    .ribbon-top-right::before,
    .ribbon-top-right::after {
      border-top-color: transparent;
      border-right-color: transparent;
    }
    .ribbon-top-right::before {
      top: 0;
      left: 23px;
    }
    .ribbon-top-right::after {
      bottom: 0;
      right: 0;
    }
    .ribbon-top-right span {
      left: -25px;
      top: 30px;
      transform: rotate(45deg);
    }

    /* bottom left*/
    .ribbon-bottom-left {
      bottom: -10px;
      left: -10px;
    }
    .ribbon-bottom-left::before,
    .ribbon-bottom-left::after {
      border-bottom-color: transparent;
      border-left-color: transparent;
    }
    .ribbon-bottom-left::before {
      bottom: 0;
      right: 23px;
    }
    .ribbon-bottom-left::after {
      top: 0;
      left: 0;
    }
    .ribbon-bottom-left span {
      right: -25px;
      bottom: 30px;
      transform: rotate(45deg);
    }

    /* bottom right*/
    .ribbon-bottom-right {
      bottom: -10px;
      right: -10px;
    }
    .ribbon-bottom-right::before,
    .ribbon-bottom-right::after {
      border-bottom-color: transparent;
      border-right-color: transparent;
    }
    .ribbon-bottom-right::before {
      bottom: 0;
      left: 23px;
    }
    .ribbon-bottom-right::after {
      top: 0;
      right: 0;
    }
    .ribbon-bottom-right span {
      left: -25px;
      bottom: 30px;
      transform: rotate(-45deg);
    }
`;

const RibbonComponent = (props: any) => {
    const {
        position = null,
        colorScheme = null,
        content = null
    } = props;

    const renderRibbon = () => {
        let ribbonClassName = "ribbon " + 
            (position != null && position != "" ? position : "ribbon-top-left") + " " +
            (colorScheme != null && colorScheme != "" ? colorScheme : "ribbon-danger");

        return <div className={ribbonClassName}>
            <span className="ribbonContent">{content}</span>
        </div>
    }

    return <RibbonContainer>
        {renderRibbon()}
    </RibbonContainer>;
}

export default RibbonComponent;
